<template>
    <main class="d-flex flex-column justify-content-between bgray-100 mh-100 vh-100">
        <b-navbar class="py-3 px-4 px-md-5"
                  toggleable="sm"
        >
            <b-navbar-brand class="header-logo cursor" @click="initData">
                <b-img class="w-100" :src="require('@shared/assets/img/common/QuantifiedESG_Logo_v3_Basic.png')"/>
            </b-navbar-brand>

            <b-navbar-nav class="ml-auto">
                <dropdownLanguage/>
            </b-navbar-nav>
        </b-navbar>
        <!-- bgray-100 pt-3 pb-5 -->
        <b-container class="bgray-100 py-3 my-auto" fluid>
            <b-row align-h="center" class="mb-3">
                <b-col cols md="8" xl="6">
                    <div class="text-center">
                        <h2 class="fw-600 mb-0"> {{ $t('공급망 ESG 실사') }} </h2>
                    </div>
                </b-col>
            </b-row>

            <b-row align-h="center" align-v="end" class="mb-4">
                <b-col cols md="8" xl="6">
                    <b-row align-v="end">
                        <b-col cols="4" md>
                            <div class="pb-1"
                                 :class="register_step === 1 ? 'border-bottom border-color-gray-700 border-width-2 fw-600 f-120 gray-900' : 'border-bottom border-color-gray-700 f-105 gray-600'">
                                <div class="f-90 mb-0">Step 1.</div>
                                <div>
                                    {{ $t(`기업 조회`) }}
                                </div>
                            </div>
                        </b-col>
                        <b-col cols="4" md>
                            <div class="pb-1"
                                 :class="register_step === 2 ? 'border-bottom border-color-gray-700 border-width-2 fw-600 f-120 gray-900' : 'border-bottom border-color-gray-700 f-105 gray-600'">
                                <div class="f-90 mb-0">Step 2.</div>
                                <div>{{ $t(`정보 입력`) }}</div>
                            </div>
                        </b-col>
                        <b-col cols="4" md>
                            <div class="pb-1"
                                 :class="register_step === 3 ? 'border-bottom border-color-gray-700 border-width-2 fw-600 f-120 gray-900' : 'border-bottom border-color-gray-700 f-105 gray-600'">
                                <div class="f-90 mb-0">Step 3.</div>
                                <div>{{ $t(`신청완료`) }}</div>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>

            <b-row align-v="end" align-h="center">
                <b-col cols md="8" xl="6">
                    <b-row>
                        <b-col cols>
                            <b-card class="px-lg-3 px-lg-4 py-3 shadow-sm">
                                <template v-if="!is_project_duplicated">
                                    <RegisterStep1 v-if="register_step === 1"/>
                                    <RegisterStep2 v-if="register_step === 2"
                                                   :prop-loading="loading"
                                                   @toRequestAssessment="requestAssessment"
                                                   @duplicatedRequest="catchDuplicatedOnStep2"
                                    />
                                    <RegisterStep3 v-if="register_step === 3"
                                                   :prop-loading="loading"
                                                   :requested-details="requestedDetails"
                                    />
                                </template>
                                <template v-else>
                                    <DuplicatedRequestInfo :e_mail="to_dup_e_mail" :prop-loading="loading"/>
                                </template>
                            </b-card>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>

        <DisabilityFormModal/>
        <global-footer/>
    </main>
</template>

<script>
import * as Sentry from '@sentry/vue';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';

import GlobalFooter from '@shared/components/common/GlobalFooter.vue';
import dropdownLanguage from '@shared/components/utils/dropdown-language.vue';
import locale_computed from '@shared/mixin/locale_computed';
import RegisterStep1 from '@/components/auth/Register/_SubComponents/RegisterStep1/RegisterStep1.vue';
import {mapActions, mapState} from 'vuex';
import RegisterStep2 from '@/components/auth/Register/_SubComponents/RegisterStep2/RegisterStep2.vue';
import RegisterStep3 from '@/components/auth/Register/_SubComponents/RegisterStep3.vue';
import DisabilityFormModal from '@/components/auth/Register/_SubComponents/DisabilityFormModal.vue';
import DuplicatedRequestInfo from '@/components/auth/Register/_SubComponents/DuplicatedRequestInfo.vue';

dayjs.locale('ko');

export default {
    name: 'register',
    mixins: [locale_computed],
    components: {
        DuplicatedRequestInfo,
        DisabilityFormModal,
        RegisterStep3,
        RegisterStep2,
        RegisterStep1,
        GlobalFooter,
        dropdownLanguage,
    },
    data() {
        return {
            loading: false,
            requestedDetails: {
                period: null,
                project_code: null,
                company_name: null,
                company_code: null,
                campaign_owner: null,
                requested_email: null,
                requested_user_name: null,
                requested_phone_tell: null,
                project_access_status: null,
                project_role: null
            },
            to_dup_e_mail: null,
        };
    },
    computed: {
        ...mapState('register', ['register_loading', 'register_step', 'selected_vendor', 'is_project_duplicated']),
    },
    watch: {
        register_step(aft, bef) {
            if (aft === 1 && bef === 2) {
                this.initiateAllData();
            }
            if (aft === 2) {
                this.setIsConflictRegister(false);
                this.setIsProjectDuplicated(false);
                this.to_dup_e_mail = null;
            }
        },
    },
    async created() {
        // 테넌트별 register 런타임 설정 (brands DB) — 실패해도 코드 기본값으로 동작
        this.$store.dispatch('register/loadTenantRegisterConfig');

        if (this.$store.state.accessToken) {
            await this.$store.dispatch('logout');
        }

        // ?l= 은 앱이 문구를 가진 locale(@shared/locales/*.json) 이면 그대로 받는다.
        // 'ch' 는 이미 배포된 링크의 옛 중국어 코드라 'ca' 로 바꾼다. 모르는 값은 en.
        const query_lang = {ch: 'ca'}[this.$route.query.l] || this.$route.query.l;
        this.$i18n.locale = !query_lang
            ? 'ko'
            : this.$i18n.availableLocales.includes(query_lang) ? query_lang : 'en';
    },
    mounted() {
        this.initData();
    },
    beforeDestroy() {
        this.initData();
    },
    methods: {
        ...mapActions('register', ['initiateAllData',
            'setRegisterLoading',
            'setRegisterStep', 'setIsConflictRegister', 'setIsProjectDuplicated', 'setDuplicatedMessage']),
        initData() {
            this.initiateAllData();
            this.requestedDetails = {
                period: null,
                project_code: null,
                company_name: null,
                company_code: null,
                campaign_owner: null,
                requested_email: null,
                requested_user_name: null,
                requested_phone_tell: null,
                project_access_status: null,
                project_role: null
            };
            this.to_dup_e_mail = null;
            this.$nextTick(() => {
                this.$refs.RegisterStep1?.initData();
            });
        },
        catchDuplicatedOnStep2(e_mail) {
            this.to_dup_e_mail = e_mail;
        },
        async requestAssessment({form, project_input_form, is_user_duplicated, campaign_id}) {
            this.setRegisterLoading(true);

            try {
                await this.setRegisterStep(3);


                let _campaign_id = campaign_id;
                if (campaign_id == null && Object.keys(project_input_form).length > 0) {
                    const {data: target_campaign_res} = await this.$axios.post('/rule-engine/evaluate/match-campaign', {
                        project_id: this.selected_vendor?.project,
                        user_inputs: project_input_form
                    });
                    _campaign_id = target_campaign_res?.campaign_id;
                }

                const requestForm = {
                    project_code: this.selected_vendor?.project_code,
                    campaign_id: _campaign_id,
                    company_id: this.selected_vendor?.company?.id,
                    project_id: this.selected_vendor?.project,
                    company_name: this.selected_vendor?.company?.company_name,
                    // company_id 가 있으면 company_code 는 '저장할 번호' 다 — 첫 신청에서 새로 입력한 경우만 보낸다
                    // (서버는 저장할 수 없는 번호가 오면 422 로 거부). company_id 가 없으면 회사 조회용.
                    company_code: this.selected_vendor?.company?.id
                        ? (form.company_code || undefined)
                        : (form.company_code ?? this.selected_vendor?.company?.company_code),
                    vendor_code: this.selected_vendor?.vendor_code,
                    email: form.e_mail,
                    user_name: form.user_name,
                    password: form.password,
                    tel_office: !form.national_code ? form.tel_office : `(${form.national_code}) ${form.tel_office}`,
                    lang: this.$i18n.locale,
                    report_lang: form.report_lang,
                    country: this.selected_vendor?.company?.country || '한국',
                    country_en: this.selected_vendor?.company?.country_en || 'South Korea'
                };

                if (is_user_duplicated) {
                    delete requestForm.user_name;
                    delete requestForm.password;
                    delete requestForm.tel_office;
                }

                let _res_request_register = await this.$axios.post('/register/request', requestForm);


                // Sentry Register 성공 Breadcrumb 추가
                Sentry.addBreadcrumb({
                    level: 'Info',
                    type: 'Auth',
                    category: 'Register',
                    data: {
                        email: form.e_mail,
                        vendor_code: this.selected_vendor?.vendor_code,
                        company_name: this.selected_vendor?.company?.company_name
                    }
                });
                
                this.requestedDetails = _res_request_register.data;
                this.$emit('toast-success', this.$t('회원가입 완료'), this.$t('QESG 평가신청이 완료되었습니다'));
            } catch (error) {
                let sentry_error_message = null;
                // 아래 분기에서 사용자에게 실패를 안내했는지 여부.
                let handled = false;
                this.setIsConflictRegister(true);

                if (error.response) {
                    const {status, data} = error.response;
                    if (status === 404) {
                        sentry_error_message = data?.message;
                        if (data?.message === 'Not_Found_Project') {
                            alert('존재하지 않는 프로젝트 코드입니다. 프로젝트 코드를 확인 후 다시 신청해주세요.');
                            handled = true;
                        }
                    } else if (status === 409) {
                        sentry_error_message = data?.message;
                        if (data?.message === 'Not_Found_Project') {
                            alert('존재하지 않는 프로젝트 코드입니다. 프로젝트 코드를 확인 후 다시 신청해주세요.');
                            handled = true;
                        }
                        if (data === 'Duplicated_Request_Project') {
                            let _duplicatedMessage = {...data.request};
                            _duplicatedMessage.create_date = dayjs(_duplicatedMessage.create_date).format('YYYY년 M월 D일 HH:mm:ss');
                            _duplicatedMessage.create_date_e = dayjs(_duplicatedMessage.create_date).locale('en').format('DD/MM/YYYY ddd HH:mm:ss');
                            _duplicatedMessage.access_date = dayjs(_duplicatedMessage.access_date).format('YYYY년 M월 D일 HH:mm:ss');
                            _duplicatedMessage.access_date_e = dayjs(_duplicatedMessage.access_date).locale('en').format('DD/MM/YYYY ddd HH:mm:ss');
                            this.setIsConflictRegister(false);
                            this.setIsProjectDuplicated(true);
                            this.setDuplicatedMessage(_duplicatedMessage);
                            
                            this.to_dup_e_mail = form.e_mail;
                            handled = true;
                        }
                    } else {
                        sentry_error_message = data?.message;

                        // 메일 발송 실패 = 신청 미완료 (백엔드가 롤백한다).
                        // 예전에는 이 응답이 200 이라 성공 토스트가 떴다.
                        if (data?.code === 'email_failure') {
                            this.$showModal({
                                type: 'alert',
                                state: 'error',
                                title: this.$t('평가 신청 오류'),
                                message: this.$t('이메일 전송에 실패하여 평가 신청이 완료되지 않았습니다. 잠시 후 다시 신청해주세요.'),
                            });
                            handled = true;
                        }
                    }

                } else {
                    sentry_error_message = error.message;
                }

                // 위 분기 어디에도 걸리지 않은 응답(400 / 422 / 500 등)은 지금까지
                // 아무 안내 없이 조용히 끝났다 — 사용자는 신청이 실패한 사실조차 알 수
                // 없었다 (prod 2026-07-23, campaign_id 누락 → 422 를 500 으로 받던 건).
                // 남은 모든 실패에 대해 최소한 실패했다는 사실은 알린다.
                if (!handled) {
                    this.$showModal({
                        type: 'alert',
                        state: 'error',
                        title: this.$t('평가 신청 오류'),
                        message: this.$t('평가 신청에 실패했습니다. 잠시 후 다시 시도해주시거나, 문제가 계속되면 QESG로 문의해주세요.'),
                    });
                }

                // Sentry Register 실패 Breadcrumb 추가
                Sentry.addBreadcrumb({
                    level: 'Error',
                    type: 'Auth',
                    category: 'Register',
                    data: {
                        email: form.e_mail,
                        vendor_code: this.selected_vendor?.vendor_code,
                        company_name: this.selected_vendor?.company?.company_name,
                        message: sentry_error_message
                    }
                });
            } finally {
                this.setRegisterLoading(false);
            }
        },
    }
};

</script>

<style>
#vendor-table .b-table-row-selected.table-active {
    background-color: #b9deff38 !important;
}

.not-scroll {
    overflow: hidden;
    width: 100%;
    height: 100vh;
    touch-action: none;
}
</style>
